import { Link, useLocation } from 'react-router-dom';
import '../../assets/css/header.css'
import logo from '../../assets/images/SRP Infotech.png';
import { useEffect, useState } from 'react';
export default function Header() {
    const [active, setActive] = useState('/')
    const [headerClasses, setHeaderClasses] = useState('')
    const location = useLocation()
    useEffect(() => {
       
        if(location.pathname === '/'){
            setHeaderClasses('header position-absolute top-0 start-0 end-0 z-1')
            setActive('/')
        }else{
            setHeaderClasses('header')
        }
        if (location.pathname !== '/' && location.pathname !== active) {
            setActive(location.pathname)
        }
    }, [location.pathname])

    return (
        <header className={headerClasses}>
            <div className="navigation-wrap start-header start-style">
                <div className="col-12 px-4">
                    <nav className="navbar navbar-expand-md navbar-light pt-0 pb-0">
                        <Link className="navbar-brand d-flex flex-column justify-content-center" to="/">
                            <img src={logo} alt="logo" width="100px" height="70px" />
                            SRP Infotech</Link>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav m-auto nav">
                                <li className="nav-item ps-4 ps-md-0 ms-0 ms-md-4 ">
                                    <Link className={`nav-link ${active === '/' ? 'active' : ''}`} to="/">Home</Link>
                                </li>
                                <li className="nav-item ps-4 ps-md-0 ms-0 ms-md-4">
                                    <Link className={`nav-link ${active === '/portfolio' ? 'active' : ''}`} to="/portfolio" aria-expanded="false">Portfolio</Link>
                                    <div className="dropdown-menu">
                                        <Link className="dropdown-item" to="/portfolio" data-custom-value="application">Mobile App Design</Link>
                                        <Link className="dropdown-item" to="/portfolio" data-custom-value="website">Web Layout Design</Link>
                                        <Link className="dropdown-item" to="/portfolio" data-custom-value="game">Game Design</Link>
                                    </div>
                                </li>
                                <li className="nav-item ps-4 ps-md-0 ms-0 ms-md-4">
                                    <Link className={`nav-link ${active === '/aboutus' ? 'active' : ''}`} to="/aboutus">About US</Link>
                                </li>
                                <li className="nav-item ps-4 ps-md-0 ms-0 ms-md-4">
                                    <Link className={`nav-link ${active === '/contact' ? 'active' : ''}`} to="/contact">Contact US</Link>
                                </li>
                            </ul>
                        </div>
                        {/* <div className="hiring" hidden>
                            <a href="contact-us.html#contact">We're Hiring</a>
                        </div> */}
                    </nav>
                </div>
            </div>
        </header>
    )
}